import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

// Models
import { Membro } from '../../_models/membro';
import { VoucherPalito } from '../../_models/voucherPalito.interface';

// Services
import { Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';
import { FidelidadeService } from '../../_services/fidelidade.service';

@Component({
  selector: 'app-palito-premiado',
  templateUrl: './palito-premiado.component.html',
  styleUrls: ['./palito-premiado.component.scss'],
})
export class PalitoPremiadoComponent implements OnInit, OnDestroy {
  // Tamanho tela
  public width: number = 0;

  // Erro voucher
  public voucherInvalido: boolean = false;
  public voucherJaUtilizado: boolean = false;
  public voucherNaoEncontrado: boolean = false;
  public voucherNaoConsumido: boolean = false;

  // Membro
  public membro: Membro | undefined;
  public membroSubscription: Subscription;

  // Menu hamburguer
  public hamburguerActive: boolean = false;

  // Regulamento
  public regulamento: string[] = [];
  public exibirModalRegulamento: boolean = false;
  public obtendoRegulamento: boolean = false;

  // Popups resgate
  public exibirPopupResgateCacaus: boolean = false;
  public exibirPopupResgatePromocao: boolean = false;
  public carregandoVoucher: boolean = false;
  public cacaus: number = 0;
  public promocao: number = 0;
  private mostrarBotao: boolean = false;

  // FAQS
  public faq: any[] = [];

  // Form Voucher
  public voucherForm: UntypedFormGroup;

  constructor(
    private fidelidadeService: FidelidadeService,
    private authService: AuthService,
    private fb: UntypedFormBuilder,
    private router: Router
  ) {
    this.voucherForm = this.fb.group({
      codigo: ['', [Validators.required]],
    });
  }

  ngOnInit(): void {
    this.obterFaq();
    this.width = window.innerWidth;

    this.membroSubscription =
      this.authService.LocalStorage.currentUserMembro.subscribe((membro) => {
        this.membro = membro;
      });

    if (this.membro.tipoStatus === 7 || this.membro.tipoStatus === 11) {
      this.router.navigate(['/meusdados']);
    }
  }

  ngOnDestroy(): void {
    if (this.membroSubscription) this.membroSubscription.unsubscribe();
    this.membro = undefined;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    // Atualize as dimensões da tela quando houver um redimensionamento
    this.width = event.target.innerWidth;
  }

  // Regulamento
  public abrirModalRegulamento(): void {
    if (this.regulamento.length > 0) {
      this.exibirModalRegulamento = true;
      return;
    }

    this.obterRegulamentoPromocao(true);
    this.hamburguerActive = false;
  }

  public obterRegulamentoPromocao(exibirModal: boolean = false): void {
    this.obtendoRegulamento = true;

    this.fidelidadeService
      .obterConfiguracaoPorDescricao('RegulamentoPalitoPremiado')
      .subscribe({
        next: (res: any) =>
          this.processarSucessoObterConfiguracao(res, exibirModal),
        error: () => {
          this.obtendoRegulamento = false;
        },
      });
  }

  private processarSucessoObterConfiguracao(
    res: any,
    exibirModal: boolean
  ): void {
    console.log((this.regulamento = res.valor));
    this.regulamento = res.valor.split('  ');
    this.exibirModalRegulamento = exibirModal;
    this.obtendoRegulamento = false;
  }

  // FAQS
  private obterFaq(): void {
    this.fidelidadeService.obterFAQPorNome('Palito Premiado 2024').subscribe({
      next: (res: any) => this.processarSucessoObterFaq(res),
    });
  }

  private processarSucessoObterFaq(res: any): void {
    res = res.resultado;

    const faq: any[] = [];

    for (let i = 0; i < res.length; i++) {
      faq.push({
        pergunta: res[i].pergunta,
        resposta: res[i].resposta,
      });
    }

    this.faq = faq;
  }

  // Validação de voucher
  public voucher() {
    if (this.membro === undefined) {
      this.irParaLogin();
      return;
    }

    this.voucherInvalido = false;
    this.voucherJaUtilizado = false;
    this.voucherNaoConsumido = false;
    this.voucherNaoEncontrado = false;

    const button = document.querySelector('.botao__resgate');
    const input = document.querySelector('.lovers__input');
    input.classList.add('aparecer');
    button.classList.add('clicked');

    if (this.mostrarBotao) {
      this.carregandoVoucher = true;
      if (this.membro !== undefined) {
        const codigo = this.voucherForm.get('codigo').value;

        let voucher = {
          codigo: codigo,
        };

        this.fidelidadeService.consultarVoucher(voucher).subscribe({
          next: (res: VoucherPalito) => {
            console.log(res);
            this.processarSucessoObterConsultarVoucher(res);
          },
          error: (err: any) => {
            console.log(err);
            if (
              err.mensagensErro[0].includes(
                'Não existe voucher cadastrado com o código informado!'
              )
            ) {
              this.voucherInvalido = true;
              this.carregandoVoucher = false;
              return;
            }
            this.voucherNaoEncontrado = true;
            this.carregandoVoucher = false;
          },
        });
      } else {
        this.carregandoVoucher = false;
        this.irParaLogin();
      }
    }
    this.mostrarBotao = true;
  }

  private processarSucessoObterConsultarVoucher(res: VoucherPalito) {
    if (res.qtd < 1) {
      this.voucherJaUtilizado = true;
      this.carregandoVoucher = false;
      return;
    }

    let cacaus = res.pontos;

    let promocao = res.idPromocao;

    let voucher = {
      codigo: res.codigo,
      idMembro: this.membro.id,
    };

    this.fidelidadeService.consumirVoucher(voucher).subscribe({
      next: (res: any) => {
        console.log(res);
        if (cacaus > 0) {
          this.cacaus = cacaus;
          this.exibirPopupResgateCacaus = true;
          this.fidelidadeService.obterMembro().subscribe({
            next: (res: any) => {
              this.authService.LocalStorage.salvarMembro(res);
            },
            error: (err: any) => console.log(err),
          });
        }
        if (promocao !== null) {
          this.promocao = promocao;
          this.exibirPopupResgatePromocao = true;
        }
        this.carregandoVoucher = false;
        this.voucherForm.reset();
      },
      error: (err: any) => {
        console.log(err);
        this.voucherNaoConsumido = true;
        this.carregandoVoucher = false;
      },
    });
  }

  // Ir para home
  public irParaHome(): void {
    this.router.navigate(['/home']);
  }

  // Ir para ecommerce
  public irParaEcom(): void {
    window.location.href = 'https://www.cacaushow.com.br/';
    this.hamburguerActive = false;
  }

  public irParaEcomGelatos(): void {
    window.location.href = 'https://www.cacaushow.com.br/palito-premiado.html';
  }

  // Redireciona para LP se não logado
  private irParaLogin(): void {
    const link = '/palito-premiado';

    this.router.navigate(['/home'], {
      queryParams: {
        redirectLink: btoa(link),
        login: true,
      },
    });
  }
  //https://lovers.cacaushow.com.br/
  public irParaMeusMomentos(): void {
    this.router.navigate(['/minhas-experiencias']);
  }

  public irParaMomentosEspeciais(): void {
    this.router.navigate(['/momentos-especiais']);
  }

  // Scroll para como participar
  public scrollToComoParticipar() {
    const scrollElem = document.querySelector('#comoParticipar') as HTMLElement;
    const margin =
      2 * parseFloat(getComputedStyle(document.documentElement).fontSize);
    const scrollToPosition =
      scrollElem.getBoundingClientRect().top + window.scrollY - margin;

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth',
    });
    this.hamburguerActive = false;
  }

  // Scroll para duvidas
  public scrollToDuvidas() {
    const scrollElem = document.querySelector('#duvidas') as HTMLElement;
    const margin =
      6 * parseFloat(getComputedStyle(document.documentElement).fontSize);
    const scrollToPosition =
      scrollElem.getBoundingClientRect().top + window.scrollY - margin;

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth',
    });
    this.hamburguerActive = false;
  }

  // Scroll para voucher input
  public scrollToVoucher() {
    const scrollElem = document.querySelector('#voucherInput') as HTMLElement;
    const margin =
      6 * parseFloat(getComputedStyle(document.documentElement).fontSize);
    const scrollToPosition =
      scrollElem.getBoundingClientRect().top + window.scrollY - margin;

    window.scrollTo({
      top: scrollToPosition,
      behavior: 'smooth',
    });
  }

  // Ativa ou desativa menu hamburguer
  public iconHamburguer() {
    this.hamburguerActive = !this.hamburguerActive;
  }

  // Ir para ajuda
  public irParaAjuda(): void {
    this.router.navigate(['ajuda', 'palito-premiado'], {
      queryParams: { tipoAtendimento: 'promocao' },
    });
  }
}
